import { render } from "./faq-item.vue?vue&type=template&id=04dbe8ee&scoped=true&ts=true"
import script from "./faq-item.vue?vue&type=script&lang=ts"
export * from "./faq-item.vue?vue&type=script&lang=ts"

import "./faq-item.vue?vue&type=style&index=0&id=04dbe8ee&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dbe8ee"]])

export default __exports__